import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

import { MAX_PERIODS, emptyPeriod } from "./timeUtils";

// One From/To pair of dropdowns. "To" only lists slots after the chosen "From".
function PeriodRow({ slots, value, onChange, onRemove }) {
  const fromSlots = useMemo(() => slots.slice(0, -1), [slots]);
  const toSlots = useMemo(() => (value.from ? slots.filter((s) => s.value > value.from) : slots.slice(1)), [slots, value.from]);

  const handleFrom = (e) => {
    const from = e.target.value;
    onChange({ from, to: value.to && value.to <= from ? "" : value.to });
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <TextField select fullWidth size="small" label="From" value={value.from} onChange={handleFrom}>
        {fromSlots.map((s) => (
          <MenuItem key={s.value} value={s.value}>
            {s.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        fullWidth
        size="small"
        label="To"
        value={value.to}
        onChange={(e) => onChange({ from: value.from, to: e.target.value })}
        disabled={!value.from}
      >
        {toSlots.map((s) => (
          <MenuItem key={s.value} value={s.value}>
            {s.label}
          </MenuItem>
        ))}
      </TextField>
      <IconButton aria-label="Remove time" size="small" onClick={onRemove}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

// A scope's list of From/To periods (e.g. morning + evening), capped at MAX_PERIODS.
export default function PeriodList({ label, slots, periods, onChange }) {
  const update = (idx, next) => onChange(periods.map((p, i) => (i === idx ? next : p)));
  const remove = (idx) => onChange(periods.filter((_, i) => i !== idx));
  const add = () => onChange([...periods, emptyPeriod()]);

  return (
    <Box>
      {label && (
        <Typography variant="body2" fontWeight={600} mb={1}>
          {label}
        </Typography>
      )}
      <Box display="flex" flexDirection="column" gap={1.5}>
        {periods.map((p, idx) => (
          <PeriodRow key={idx} slots={slots} value={p} onChange={(next) => update(idx, next)} onRemove={() => remove(idx)} />
        ))}
      </Box>
      {periods.length < MAX_PERIODS && (
        <Button size="small" startIcon={<AddIcon />} onClick={add} sx={{ mt: periods.length ? 1 : 0 }}>
          Add another time
        </Button>
      )}
    </Box>
  );
}
